// cadastro.component.ts
import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'login-empresa-root',
  templateUrl: './login-empresa.component.html',
  styleUrls: ['./login-empresa.component.scss']
})
export class LoginEmpresaComponent {
  title = "Login";
  
  constructor(private _router: Router){

  }

  ngOnInit(){
    this.verificarUsuarioLogado();
    this.recuperarTipoPagina();
  }

  verificarUsuarioLogado(){

  }

  recuperarTipoPagina(){
    const endereco = this._router.url;
    if(endereco === '/login-empresa'){
      this.title = "Login";
    } else if(endereco === '/recuperar-senha'){
      this.title = "Recuperar Senha";
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/components/_public-layout/pages/login/login-empresa.component.ts